import { Theme, ThemeMode } from '@/types';

// Palette values live in src/styles/globals.css (`:root` for light, `.dark` for dark)
// and tailwind.config.js, so the theme itself carries no colour overrides.
export const KROWN1X_THEME: Theme = {
  id: 'krown1x',
  name: 'KROWN1X',
  colors: {},
};

export const LIGHT_THEME: Theme = KROWN1X_THEME;

export const THEMES: Theme[] = [KROWN1X_THEME];

export const DEFAULT_THEME_MODE: ThemeMode = 'light';
export const DEFAULT_THEME: Theme = KROWN1X_THEME;

export const THEME_STORAGE_KEY = 'admin-template-theme';
export const THEME_MODE_STORAGE_KEY = 'admin-template-theme-mode';

export function getSystemTheme(): 'light' | 'dark' {
  return 'light';
}

export function applyTheme(_theme: Theme, mode: ThemeMode) {
  const root = document.documentElement;

  // Clear anything left behind by earlier multi-theme builds
  root.className = root.className.replace(/theme-\w+/g, '');
  root.classList.toggle('dark', mode === 'dark');
}

export function saveThemePreference(theme: Theme, mode: ThemeMode) {
  if (typeof window === 'undefined') return;

  localStorage.setItem(THEME_STORAGE_KEY, theme.id);
  localStorage.setItem(THEME_MODE_STORAGE_KEY, mode);
}

export function getStoredThemePreference(): { theme: Theme; mode: ThemeMode } {
  if (typeof window === 'undefined') return { theme: DEFAULT_THEME, mode: DEFAULT_THEME_MODE };

  const stored = localStorage.getItem(THEME_MODE_STORAGE_KEY);
  const mode: ThemeMode = stored === 'dark' ? 'dark' : 'light';
  return { theme: DEFAULT_THEME, mode };
}
